import { render } from "./Partner.vue?vue&type=template&id=4f37d560&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=4f37d560&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f37d560"]])

export default __exports__